module.exports = __webpack_public_path__ + "static/media/YF23_1.8528ec91.jpg";